<template>
  <div class="p-2" style="border:solid 1px #DFDFDF;">
    <div class="float-left ml-1" style="width:300px;">
      <font-awesome-icon :icon="associate.srch_type== 'O' ? 'building' : 'male'" class="mr-2" />
      <strong>{{associate.asso_name}}</strong>
      (Associate)
      <font-awesome-icon
        v-if="associate.srch_asso_rdc_indivi_alrt.length > 0"
        class="text-danger ml-3"
        icon="exclamation-triangle"
      />
      ({{associate.srch_asso_rdc_indivi_alrt.length}})
      <br />
    </div>

    <span v-if="associate.srch_asso_rdc_indivi_alrt.length == 0">
      <b-badge variant="success" class="mr-3">No Alerts</b-badge>
    </span>

    <span v-if="associate.srch_asso_rdc_indivi_alrt.length > 0">
      <b-badge variant="success" class="mr-3">Negative Alerts: {{negativeAlerts.length}}</b-badge>
    </span>
    <span>
      <b-badge variant="danger">Positive Alerts: {{positiveAlerts.length}}</b-badge>
    </span>
    <span>
      <b-badge variant="warning" class="ml-2">Pending: {{pendingAlerts}}</b-badge>
    </span>
    <span v-if="negativeAlerts.length == 0 && positiveAlerts.length == 0">
      <b-badge variant="warning" class="ml-2">Status: Pending</b-badge>
    </span>
    <span v-else>
      <b-badge
        v-if="negativeAlerts.length > 0"
        variant="success"
        class="ml-2"
      >Status: Remediated Green</b-badge>
      <b-badge v-else variant="danger" class="ml-2">Status: Remediated Red</b-badge>
    </span>
    <b-button
      v-if="associate.srch_asso_rdc_indivi_alrt.length > 0"
      @click="collapse = !collapse"
      variant="primary"
      size="sm"
      class="float-right"
    >
      <font-awesome-icon :icon="collapse ? 'minus' : 'plus'" />
    </b-button>
    <div class="clearfix"></div>
    <b-collapse id="collapse-1" class="mt-2" v-model="collapse">
      <b-card>
        <b-tabs content-class="mt-3">
          <b-tab active>
            <template v-slot:title>
              <font-awesome-icon class="text-danger" icon="exclamation-triangle" />
              Alerts ({{associate.srch_asso_rdc_indivi_alrt.length}})
            </template>
            <div
              v-if="associate.srch_asso_rdc_indivi_alrt.length >0"
              v-for="(alert,alertIndex) in associate.srch_asso_rdc_indivi_alrt"
              :key="alertIndex"
            >
              <rdc-alert
                :alert="alert"
                :alertIndex="alertIndex"
                :entityType="associate.srch_type"
                @getStatus="calculateAlerts"
              ></rdc-alert>
            </div>
          </b-tab>
          <!--         <b-tab title="Overview"  class="text-left">-->
          <!--            <b-card-group deck>-->
          <!--             -->
          <!--              <b-card title="" header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0"><font-awesome-icon class="text-danger" icon="exclamation-triangle" /> Post Remediation ({{associate.srch_asso_rdc_indivi_alrt.length || 0}})</h6>-->
          <!--                </template>-->
          <!--                -->
          <!--                <p><font-awesome-icon class="text-danger" icon="exclamation-triangle" />&nbsp;Positive Alerts: {{associate.srch_asso_rdc_indivi_alrt.length || 0}}</p>-->
          <!--                <p><font-awesome-icon class="text-success" icon="ban" />&nbsp;Negative Alerts: {{associate.srch_asso_rdc_indivi_alrt.length || 0}}</p>-->

          <!--                <hr>-->
          <!--                <p>Sources:</p>-->
          <!--                <b-badge class="mr-2" v-for="(source,sourceIndex) in riskSources" :key="sourceIndex">{{source+' 5'}}</b-badge>-->
          <!--                <hr>-->
          <!--                <p>Categories:</p>-->
          <!--                <b-badge class="mr-2" v-for="(category,categoryIndex) in riskCategories" :key="categoryIndex">{{category +' 2'}}</b-badge>-->
          <!--                <p>Sub Categories:</p>-->
          <!--                <b-badge class="mr-2" v-for="(subCategory,subCategoryindex) in riskSubCategories" :key="subCategoryindex">{{subCategory +' 2'}}</b-badge>-->
          <!--                -->
          <!--              </b-card>-->
          <!--              <b-card header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0">PRM</h6>-->
          <!--                </template>-->
          <!--                <p><font-awesome-icon class="text-danger" icon="exclamation-triangle" />&nbsp;Positive Alerts: {{associate.srch_asso_rdc_indivi_alrt.length || 0}}</p>-->
          <!--                <p><font-awesome-icon class="text-success" icon="ban" />&nbsp;Negative Alerts: {{associate.srch_asso_rdc_indivi_alrt.length || 0}}</p>-->
          <!--              </b-card>-->
          <!--              <b-card header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0">Waldo Match</h6>-->
          <!--                </template>-->
          <!--                <p><font-awesome-icon class="text-danger" icon="exclamation-triangle" />&nbsp;Positive Alerts: {{associate.srch_asso_rdc_indivi_alrt.length || 0}}</p>-->
          <!--                <p><font-awesome-icon class="text-success" icon="ban" />&nbsp;Negative Alerts: {{associate.srch_asso_rdc_indivi_alrt.length || 0}}</p>-->
          <!--              </b-card>-->
          <!--            -->
          <!--            </b-card-group>-->
          <!--          </b-tab>-->
        </b-tabs>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import entityCompanyDetails from "./entity-company-details.vue";
import rdcAlert from "./RDCAlert.vue";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import moment from "moment";

export default {
  name: "AssociateOverview",
  components: {
    entityCompanyDetails,
    rdcAlert
  },
  data() {
    return {
      temp: [],
      // for alerts
      negativeAlerts: [],
      positiveAlerts: [],
      pendingAlerts: 0,
      totalEntityAlerts: 0,

      remediationStatus: null,
      collapse: false,
      date: null,
      riskCategories: [],
      riskSubCategories: ["EFG", "HIJ", "LMN", "OPQ", "RST"],
      riskSources: ["RiskConnect", "OFAC", "Factiva", "Bloomsberg"]
    };
  },
  created() {},
  mounted() {
    // // console.log("this.associate", this.associate)
    if (
      this.associate.srch_asso_rdc_indivi_alrt &&
      this.associate.srch_asso_rdc_indivi_alrt.length
    ) {
      this.pendingAlerts = this.associate.srch_asso_rdc_indivi_alrt.length;
      this.totalEntityAlerts = this.associate.srch_asso_rdc_indivi_alrt.length;
    }
  },
  validations: {},
  computed: {
    ...mapGetters([]),
    ...mapState(["toggleAllCoppalse"])
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    }
  },
  methods: {
    getUnique(array) {
      var uniqueArray = [];
      // Loop through array values
      for (var value of array) {
        if (uniqueArray.indexOf(value) === -1) {
          uniqueArray.push(value);
        }
      }
      return uniqueArray;
    },
    calculateAlerts(status, alert) {
      // this.negativeAlerts.splice(this.negativeAlerts.indexOf(alert.id), 1)
      // this.positiveAlerts.splice(this.positiveAlerts.indexOf(alert.id), 1)
      // // console.log("alert", alert.id);
      // // console.log('positivealerts',this.positiveAlerts );
      // // console.log('negativealerts',this.negativeAlerts );
      // // console.log('pendingalerts',this.pendingAlerts );
      // // console.log("----calculateAlerts-----", status)
      switch (status) {
        case "postive alert":
          // code block

          this.positiveAlerts.push(alert.id);
          let negativeIndex = this.negativeAlerts.indexOf(alert.id);
          if (negativeIndex != -1) {
            this.negativeAlerts.splice(
              this.negativeAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalPositiveAlerts -= 1;
          }
          // this.pendingAlerts = this.totalEntityAlerts - (this.positiveAlerts.length +  this.negativeAlerts.length)
          this.pendingAlerts =
            this.totalEntityAlerts -
            (this.positiveAlerts.length + this.negativeAlerts.length);
          // this.$store.state.totalPendingAlerts = (this.$store.state.totalAlerts -  this.totalEntityAlerts) + this.pendingAlerts // calculatin total pending alets
          this.$store.state.totalPositiveAlerts += 1; // sum of all positive alerts
          this.$store.state.totalRemidiatedAlerts =
            this.$store.state.totalPositiveAlerts +
            this.$store.state.totalNegativeAlerts; // calculatin total remediation alets
          this.$store.state.totalPendingAlerts =
            this.$store.state.totalAlerts -
            this.$store.state.totalRemidiatedAlerts; // calculatin total pending alets

          break;
        case "negative alert":
          this.negativeAlerts.push(alert.id);
          let positiveIndex = this.positiveAlerts.indexOf(alert.id);
          if (positiveIndex != -1) {
            this.positiveAlerts.splice(
              this.positiveAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalNegativeAlerts -= 1;
          }
          this.pendingAlerts =
            this.totalEntityAlerts -
            (this.positiveAlerts.length + this.negativeAlerts.length);
          // this.$store.state.totalPendingAlerts = (this.$store.state.totalAlerts -  this.totalEntityAlerts) + this.pendingAlerts // calculatin total pending alets
          this.$store.state.totalNegativeAlerts += 1; // sum of all negative alerts
          this.$store.state.totalRemidiatedAlerts =
            this.$store.state.totalPositiveAlerts +
            this.$store.state.totalNegativeAlerts; // calculatin total remediation alets
          this.$store.state.totalPendingAlerts =
            this.$store.state.totalAlerts -
            this.$store.state.totalRemidiatedAlerts; // calculatin total pending alets

          // code block
          break;
        case "pending":
          // this.negativeAlerts.splice(this.negativeAlerts.indexOf(alert.id), 1)
          // this.positiveAlerts.splice(this.positiveAlerts.indexOf(alert.id), 1)
          if (this.negativeAlerts.indexOf(alert.id) != -1) {
            this.negativeAlerts.splice(
              this.negativeAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalNegativeAlerts -= 1;
          }
          if (this.positiveAlerts.indexOf(alert.id) != -1) {
            this.positiveAlerts.splice(
              this.positiveAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalPositiveAlerts -= 1;
          }
          this.pendingAlerts =
            this.totalEntityAlerts -
            (this.positiveAlerts.length + this.negativeAlerts.length);
          // this.$store.state.totalPendingAlerts = (this.$store.state.totalAlerts -  this.totalEntityAlerts) + this.pendingAlerts // calculatin total pending alets
          this.$store.state.totalRemidiatedAlerts =
            this.$store.state.totalPositiveAlerts +
            this.$store.state.totalNegativeAlerts; // calculatin total remediation alets
          this.$store.state.totalPendingAlerts =
            this.$store.state.totalAlerts -
            this.$store.state.totalRemidiatedAlerts; // calculatin total pending alets

        default:
        // code block
      }
    }
  },
  props: {
    associate: Object
  }
};
</script>

